import { Highlightable } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnDestroy, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from '@services/menu.service';
import { IReport } from '@services/report.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-list-item',
	templateUrl: './list-item.component.html',
	styleUrls: ['./list-item.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ListItemComponent implements Highlightable, OnDestroy {
	@Input() item;
	@Input() index;
	@Input() disabled = false;
	@Output() selected = new EventEmitter<IReport>();
	private _isActive = false;
	selectedId: string;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private menuService: MenuService,
		private translateService: TranslateService,
	) {
		this.menuService.reportSelect$.pipe(takeUntil(this.unsubscribe)).subscribe((r) => {
			let reportId;
			if (r) {
				// Depending on endpoint - see report.service.ts:210
				reportId = r.reportId ? r.reportId : r.id;
			}
			this.selectedId = reportId;
		});
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	@HostBinding('class.active') get isActive() {
		return this._isActive;
	}

	setActiveStyles() {
		this._isActive = true;
	}

	setInactiveStyles() {
		this._isActive = false;
	}

	getLabel() {
		return this.item === undefined ? '' : this.item.report.name;
	}

	selectItem(item: IReport) {
		this.selected.emit(item);
	}

	categoryHeader(item): string {
		let retval: boolean | string;

		if (this.index === 0) {
			this.menuService.reportCategoryBeingIterated = '';
		}

		const heading = item.report.categoryName ? item.report.categoryName : this.translateService.instant('insights.administration.reports.categories.uncategorized');
		if (heading !== this.menuService.reportCategoryBeingIterated) {
			retval = `<div class='category-heading'>${heading}</div>`;
		} else {
			retval = '';
		}

		this.menuService.reportCategoryBeingIterated = heading;
		return retval;
	}
}
